module.exports = __webpack_public_path__ + "static/img/shopimg-default.726bdb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newimages/shopimg-default.png
// module id = MNV3
// module chunks = 48